// libs
import { get, isEmpty, omit } from 'lodash'
import { SubmissionError } from 'redux-form'

// TODO: deprecated
export function parseGraphQLErrorMessages(error) {
  if (!isEmpty(error.graphQLErrors)) {
    return error.graphQLErrors.map(({ message }) => message).join('. ')
  }

  return error.message
}

export const parseGraphQLErrorExtensions = (error) => {
  if (isEmpty(error.graphQLErrors)) {
    return null
  } else {
    let codes = {}

    error.graphQLErrors.forEach(({ extensions }) => {
      const inputs = omit(get(extensions, 'exception', {}), ['stacktrace'])

      codes = {
        ...inputs
      }
    })

    return codes
  }
}

type AnyError = any

const extractCode = (e: AnyError): string | undefined => {
  return e?.extensions?.code ?? e?.extensions?.exception?.code ?? e?.code
}

export const parseGraphQLErrorCodes = (error: AnyError) => {
  // ApolloError -> CombinedGraphQLErrors -> error.errors: GraphQLFormattedError[]
  const combined = Array.isArray(error?.errors) ? error.errors : null

  if (combined?.length) {
    const codes = combined.map(extractCode).filter(Boolean)

    return codes.length ? codes : undefined
  }

  // ApolloError -> error.graphQLErrors
  const gql = Array.isArray(error?.graphQLErrors) ? error.graphQLErrors : null

  if (gql?.length) {
    const codes = gql.map(extractCode).filter(Boolean)

    return codes.length ? codes : undefined
  }

  return error?.code
}

type GraphQLErrorLike = {
  message?: string
  extensions?: {
    code?: string
    exception?: {
      code?: string
    }
  }
}

type ApolloErrorLike = {
  errors?: GraphQLErrorLike[]
  graphQLErrors?: GraphQLErrorLike[]
  code?: string
  message?: string
}

export interface HandleSafeGraphQLErrorOptions {
  allowedCodes: string[]
  error?: ApolloErrorLike | null
  logPrefix?: string
}

export const handleSafeGraphQLErrors = ({
  allowedCodes,
  error,
  logPrefix
}: HandleSafeGraphQLErrorOptions): never | void => {
  // Apollo v4 → CombinedGraphQLErrors
  const combinedErrors = Array.isArray(error?.errors) ? error.errors : []

  // Apollo v3 → ApolloError
  const legacyErrors = Array.isArray(error?.graphQLErrors) ? error.graphQLErrors : []

  const graphQLErrors = combinedErrors.length ? combinedErrors : legacyErrors

  const safeErrors = graphQLErrors.filter(
    (err: any) => err?.extensions?.code && allowedCodes.includes(err.extensions.code)
  )

  if (!safeErrors.length) {
    if (logPrefix) {
      console.log(logPrefix, parseGraphQLErrorMessages(error))
    }
    return
  }

  const message = safeErrors
    .map((err: any) => err?.message)
    .filter(Boolean)
    .join(', ')

  throw new SubmissionError({
    _error: message
  })
}
